export default [
  {
    name: "A: 2 ranged weapons & 2 melee weapons",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Melee", "Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "bf69bf6b-5429-4419-a04d-0d19b55df4ef",
        modelTypeName: null,
        unitId: "27f7d7fa-79c1-432e-be23-13d80ef86ec6",
      },
    ],
    units: [
      {
        id: "27f7d7fa-79c1-432e-be23-13d80ef86ec6",
        leader: false,
        name: "A: 2 ranged weapons & 2 melee weapons > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Ranged weapon 1",
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 4,
                id: "3d091976-d417-4769-b677-f77371767771",
                bs: 3,
                ws: null,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Rapid fire 1",
                        type: "reserved",
                      },
                    ],
                    conditions: [
                      {
                        text: "Range",
                        type: "range",
                        data: {
                          range: {
                            title: "Within half range",
                            key: "withinHalfRange",
                          },
                        },
                        description: "Check attack range.",
                        preselected: false,
                      },
                    ],
                    description: "Increase attacks by 1 (within half range)",
                    effect: {
                      text: "Increase weapon attacks",
                      type: "increaseWeaponAttacks",
                      data: {
                        increaseWeaponAttacksValue: 1,
                        applyToExtraAttacks: false,
                      },
                    },
                    id: "d717ab6d-863b-4d8b-adce-6c693c5cb2ac",
                    scope: ["weapon"],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                nameUnique: "Ranged weapon 1",
              },
              {
                name: "Ranged weapon 2",
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 1,
                id: "6b4bb6e3-f1b4-420e-8bba-5d6ea989bc41",
                bs: 3,
                ws: null,
                nameUnique: "Ranged weapon 2",
                abilities: [],
              },
              {
                name: "Melee weapon 1",
                type: "Melee",
                attacks: 4,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "bcbf96e4-3d11-4422-805c-72f8b4fef263",
                countPerUnit: 1,
                bs: null,
                ws: 3,
                nameUnique: "Melee weapon 1",
                abilities: [],
              },
              {
                name: "Melee weapon 2",
                type: "Melee",
                attacks: 2,
                strength: 5,
                ap: -1,
                damage: 1,
                id: "1d7f0173-1dfb-43bd-a6f1-604c08a7663a",
                countPerUnit: 1,
                bs: null,
                ws: 3,
                nameUnique: "Melee weapon 2",
                abilities: [],
              },
            ],
            id: "bf69bf6b-5429-4419-a04d-0d19b55df4ef",
            name: "A: 2 ranged weapons & 2 melee weapons > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [
      "bcbf96e4-3d11-4422-805c-72f8b4fef263",
      "1d7f0173-1dfb-43bd-a6f1-604c08a7663a",
    ],
    weapons_selected_ranged: [
      "3d091976-d417-4769-b677-f77371767771",
      "6b4bb6e3-f1b4-420e-8bba-5d6ea989bc41",
    ],
  },
  {
    name: "A: 40 bolters @ BS2",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "6f282363-9ebe-4107-a76d-d8ef4f5d6a38",
        modelTypeName: null,
        unitId: "035807c4-dc89-4276-9881-a8be7b019827",
      },
    ],
    units: [
      {
        id: "035807c4-dc89-4276-9881-a8be7b019827",
        leader: false,
        name: "A: 40 bolters @ BS2 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Bolter",
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 40,
                id: "e7af6343-a785-4126-bbb1-602b83511ea0",
                bs: 2,
                ws: null,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Rapid fire 1",
                        type: "reserved",
                      },
                    ],
                    conditions: [
                      {
                        text: "Range",
                        type: "range",
                        data: {
                          range: {
                            title: "Within half range",
                            key: "withinHalfRange",
                          },
                        },
                        description: "Check attack range.",
                        preselected: false,
                      },
                    ],
                    description: "Increase attacks by 1 (within half range)",
                    effect: {
                      text: "Increase weapon attacks",
                      type: "increaseWeaponAttacks",
                      data: {
                        increaseWeaponAttacksValue: 1,
                        applyToExtraAttacks: false,
                      },
                    },
                    id: "f5445cf5-8401-4a16-91cd-66e86c5a24e5",
                    scope: ["weapon"],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                nameUnique: "Bolter",
              },
            ],
            id: "6f282363-9ebe-4107-a76d-d8ef4f5d6a38",
            name: "A: 40 bolters @ BS2 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["e7af6343-a785-4126-bbb1-602b83511ea0"],
  },
  {
    name: "A: 20 bolters @ BS3",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "c1961467-d08b-4298-b629-02c74855ef76",
        modelTypeName: null,
        unitId: "c69aa570-4ca7-4346-b58b-073351390055",
      },
    ],
    units: [
      {
        id: "c69aa570-4ca7-4346-b58b-073351390055",
        leader: false,
        name: "A: 20 bolters @ BS3 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Bolter",
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 20,
                id: "cac132aa-ca50-483a-8937-8a46a61060dc",
                bs: 3,
                ws: null,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Rapid fire 1",
                        type: "reserved",
                      },
                    ],
                    conditions: [
                      {
                        text: "Range",
                        type: "range",
                        data: {
                          range: {
                            title: "Within half range",
                            key: "withinHalfRange",
                          },
                        },
                        description: "Check attack range.",
                        preselected: false,
                      },
                    ],
                    description: "Increase attacks by 1 (within half range)",
                    effect: {
                      text: "Increase weapon attacks",
                      type: "increaseWeaponAttacks",
                      data: {
                        increaseWeaponAttacksValue: 1,
                        applyToExtraAttacks: false,
                      },
                    },
                    id: "23209fc7-17c0-4d63-80b1-2dbda21f9ab8",
                    scope: ["weapon"],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                nameUnique: "Bolter",
              },
            ],
            id: "c1961467-d08b-4298-b629-02c74855ef76",
            name: "A: 20 bolters @ BS3 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["cac132aa-ca50-483a-8937-8a46a61060dc"],
  },
  {
    name: "A: 20 bolters @ BS6",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "c3f71870-8340-4120-81b4-aef3defd6d4d",
        modelTypeName: null,
        unitId: "fe5db317-a45f-4188-b2fa-41fcb769704f",
      },
    ],
    units: [
      {
        id: "fe5db317-a45f-4188-b2fa-41fcb769704f",
        leader: false,
        name: "A: 20 bolters @ BS6 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Bolter",
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 20,
                id: "a3c0e72b-2105-4d1a-ac5a-563509640ed1",
                bs: 6,
                ws: null,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Rapid fire 1",
                        type: "reserved",
                      },
                    ],
                    conditions: [
                      {
                        text: "Range",
                        type: "range",
                        data: {
                          range: {
                            title: "Within half range",
                            key: "withinHalfRange",
                          },
                        },
                        description: "Check attack range.",
                        preselected: false,
                      },
                    ],
                    description: "Increase attacks by 1 (within half range)",
                    effect: {
                      text: "Increase weapon attacks",
                      type: "increaseWeaponAttacks",
                      data: {
                        increaseWeaponAttacksValue: 1,
                        applyToExtraAttacks: false,
                      },
                    },
                    id: "2e7a30dd-5f45-4fbf-a7de-e965aadf2bd6",
                    scope: ["weapon"],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                nameUnique: "Bolter",
              },
            ],
            id: "c3f71870-8340-4120-81b4-aef3defd6d4d",
            name: "A: 20 bolters @ BS6 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["a3c0e72b-2105-4d1a-ac5a-563509640ed1"],
  },
  {
    name: "A: 10 bolters @ BS3",
    computed_keywords: [],
    computed_leaders: [],
    computed_points: 150,
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "84d6848e-0cdb-4eb4-b6b1-cd9683f0fd87",
        modelTypeName: null,
        unitId: "92f9a8dc-494f-41d4-b907-0aa581e3b101",
      },
    ],
    units: [
      {
        id: "92f9a8dc-494f-41d4-b907-0aa581e3b101",
        leader: false,
        name: "A: 10 bolters @ BS3 > Unit 1",
        points: 150,
        abilities: [],
        model_types: [
          {
            weapons: [
              {
                name: "Bolter",
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                countPerUnit: 10,
                id: "462e9984-8a24-439c-8916-5d9e2fb34ce7",
                bs: 3,
                ws: null,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Rapid fire 1",
                        type: "reserved",
                      },
                    ],
                    conditions: [
                      {
                        text: "Range",
                        type: "range",
                        data: {
                          range: {
                            title: "Within half range",
                            key: "withinHalfRange",
                          },
                        },
                        description: "Check attack range.",
                        preselected: false,
                      },
                    ],
                    description: "Increase attacks by 1 (within half range)",
                    effect: {
                      text: "Increase weapon attacks",
                      type: "increaseWeaponAttacks",
                      data: {
                        increaseWeaponAttacksValue: 1,
                        applyToExtraAttacks: false,
                      },
                    },
                    id: "22b9f522-08c1-4477-93bf-577d13423210",
                    scope: ["weapon"],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                nameUnique: "Bolter",
              },
            ],
            id: "84d6848e-0cdb-4eb4-b6b1-cd9683f0fd87",
            name: "A: 10 bolters @ BS3 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["462e9984-8a24-439c-8916-5d9e2fb34ce7"],
  },
  {
    name: "A: 10 heavy bolters @ BS3",
    computed_keywords: [],
    computed_leaders: [],
    computed_points: 320,
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "630d634c-6b41-4010-943c-11bfe8717464",
        modelTypeName: null,
        unitId: "4ccdf136-c21e-490a-a34c-6f97a8b73e62",
      },
    ],
    units: [
      {
        id: "4ccdf136-c21e-490a-a34c-6f97a8b73e62",
        leader: false,
        name: "A: 10 heavy bolters @ BS3 > Unit 1",
        points: 320,
        abilities: [],
        model_types: [
          {
            weapons: [
              {
                name: "Heavy bolter",
                type: "Ranged",
                attacks: 3,
                strength: 5,
                ap: -1,
                damage: 2,
                countPerUnit: 10,
                id: "20598fa1-a2eb-4fe6-ae7a-f8a6dbd5a064",
                bs: 3,
                ws: null,
                nameUnique: "Heavy bolter",
                abilities: [],
              },
            ],
            id: "630d634c-6b41-4010-943c-11bfe8717464",
            name: "A: 10 heavy bolters @ BS3 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["20598fa1-a2eb-4fe6-ae7a-f8a6dbd5a064"],
  },
  {
    name: "A: 10 3 shot Strength 3 guns @ BS3",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "0ee1feb1-54ff-4657-94c1-f84eee3fa6fa",
        modelTypeName: null,
        unitId: "1b2ea4c5-ea57-4655-97e5-f3ec3db61d75",
      },
    ],
    units: [
      {
        id: "1b2ea4c5-ea57-4655-97e5-f3ec3db61d75",
        leader: false,
        name: "A: 10 3 shot Strength 3 guns @ BS3 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Baseline with weapon ability",
                type: "Ranged",
                attacks: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                countPerUnit: 10,
                id: "7d95b296-1219-4397-9f57-41280a07904c",
                bs: 3,
                ws: null,
                nameUnique: "Baseline with weapon ability",
                abilities: [],
              },
            ],
            id: "0ee1feb1-54ff-4657-94c1-f84eee3fa6fa",
            name: "A: 10 3 shot Strength 3 guns @ BS3 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["7d95b296-1219-4397-9f57-41280a07904c"],
  },
  {
    name: "A: Weapon type: Rapid Fire",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "796892c2-c628-4a5d-becb-a006dadaf0a2",
        modelTypeName: null,
        unitId: "673fc14e-72f4-4763-b5c4-71a744c7ea79",
      },
    ],
    units: [
      {
        id: "673fc14e-72f4-4763-b5c4-71a744c7ea79",
        leader: false,
        name: "A: Weapon type: Rapid Fire > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Bolt rifle",
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: -1,
                damage: 1,
                countPerUnit: 5,
                id: "b6b929f9-4dea-42f2-b448-1048ab00028e",
                bs: 3,
                ws: null,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Rapid fire 1",
                        type: "reserved",
                      },
                    ],
                    conditions: [
                      {
                        text: "Range",
                        type: "range",
                        data: {
                          range: {
                            title: "Within half range",
                            key: "withinHalfRange",
                          },
                        },
                        description: "Check attack range.",
                        preselected: false,
                      },
                    ],
                    description: "Increase attacks by 1 (within half range)",
                    effect: {
                      text: "Increase weapon attacks",
                      type: "increaseWeaponAttacks",
                      data: {
                        increaseWeaponAttacksValue: 1,
                        applyToExtraAttacks: false,
                      },
                    },
                    id: "0673db0a-4b4e-46e5-895a-f39c5c8102d6",
                    scope: ["weapon"],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                nameUnique: "Bolt rifle",
              },
            ],
            id: "796892c2-c628-4a5d-becb-a006dadaf0a2",
            name: "A: Weapon type: Rapid Fire > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["b6b929f9-4dea-42f2-b448-1048ab00028e"],
  },
  {
    name: "A: 9 flechette carbines @ BS3",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Melee", "Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "873ab262-23e7-417b-951b-f2c8219d90a9",
        modelTypeName: null,
        unitId: "96f20a08-70a6-4974-b74c-53291404fc31",
      },
    ],
    units: [
      {
        id: "96f20a08-70a6-4974-b74c-53291404fc31",
        leader: false,
        name: "A: 9 flechette carbines @ BS3 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Close combat weapon",
                type: "Melee",
                attacks: 19,
                strength: 3,
                ap: 0,
                damage: 1,
                id: "91cb271f-dd11-4109-b598-4532860d833f",
                countPerUnit: 1,
                bs: null,
                ws: 3,
                nameUnique: "Close combat weapon",
                abilities: [],
              },
              {
                name: "Flechette carbine",
                type: "Ranged",
                attacks: 5,
                strength: 3,
                ap: 0,
                damage: 1,
                countPerUnit: 9,
                id: "305a62f9-28a6-4886-a9ee-e1ab9de8810d",
                bs: 3,
                ws: null,
                nameUnique: "Flechette carbine",
                abilities: [],
              },
            ],
            id: "873ab262-23e7-417b-951b-f2c8219d90a9",
            name: "A: 9 flechette carbines @ BS3 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: ["91cb271f-dd11-4109-b598-4532860d833f"],
    weapons_selected_ranged: ["305a62f9-28a6-4886-a9ee-e1ab9de8810d"],
  },
  {
    name: "A: 10 3 damage guns @ BS3",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "72239e46-95b5-4ee1-8bb4-381823fd23a9",
        modelTypeName: null,
        unitId: "dc63d656-0115-48ba-a4c7-fdedf166574d",
      },
    ],
    units: [
      {
        id: "dc63d656-0115-48ba-a4c7-fdedf166574d",
        leader: false,
        name: "A: 10 3 damage guns @ BS3 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Damage 3 gun",
                type: "Ranged",
                attacks: 2,
                strength: 6,
                ap: -3,
                damage: 3,
                countPerUnit: 10,
                id: "ce013fd9-ecba-4e9f-89c8-072d93f9f9a0",
                bs: 3,
                ws: null,
                nameUnique: "Damage 3 gun",
                abilities: [],
              },
            ],
            id: "72239e46-95b5-4ee1-8bb4-381823fd23a9",
            name: "A: 10 3 damage guns @ BS3 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["ce013fd9-ecba-4e9f-89c8-072d93f9f9a0"],
  },
  {
    name: "A: MWs on wounds of 6",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "9f79bde3-7110-4348-9870-b515a1f2297c",
        modelTypeName: null,
        unitId: "2ec25ff1-bdda-4da8-a99d-0d0e997beb13",
      },
    ],
    units: [
      {
        id: "2ec25ff1-bdda-4da8-a99d-0d0e997beb13",
        leader: false,
        name: "A: MWs on wounds of 6 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "High volume - no MWs",
                type: "Ranged",
                attacks: 6,
                strength: 3,
                ap: 0,
                damage: 1,
                countPerUnit: 10,
                id: "0f3ce3d8-4cdd-479e-bfb0-38d4b2088323",
                bs: 3,
                ws: null,
                nameUnique: "High volume - no MWs",
                abilities: [],
              },
              {
                name: "High volume - MWs on 6s",
                type: "Ranged",
                attacks: 6,
                strength: 3,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    description:
                      "Wound roll of 6 (unmodified) : 1 mortal wound",
                    id: "23e4dd3e-bc0d-4219-8c39-cbede04c8846",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Exact",
                            key: "exact",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        attackSequenceEnds: false,
                        cap: null,
                        mortalWoundsValue: 1,
                        matchWeaponDamage: false,
                      },
                      text: "Mortal wounds",
                      type: "mortalWounds",
                    },
                    scope: ["weapon"],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                countPerUnit: 10,
                id: "90cdd748-1aa8-4bc9-aebe-93d35cea0c5d",
                bs: 3,
                ws: null,
                nameUnique: "High volume - MWs on 6s",
              },
            ],
            id: "9f79bde3-7110-4348-9870-b515a1f2297c",
            name: "A: MWs on wounds of 6 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "0f3ce3d8-4cdd-479e-bfb0-38d4b2088323",
      "90cdd748-1aa8-4bc9-aebe-93d35cea0c5d",
    ],
  },
  {
    name: "A: Melee - taser weapons",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Melee"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "573b9cd4-a69f-40c7-9f30-9f7cddab50eb",
        modelTypeName: null,
        unitId: "d9d1ab82-8521-4b91-b07f-fa72beeef8b1",
      },
    ],
    units: [
      {
        id: "d9d1ab82-8521-4b91-b07f-fa72beeef8b1",
        leader: false,
        name: "A: Melee - taser weapons > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Taser goad",
                type: "Melee",
                attacks: 11,
                strength: 6,
                ap: -1,
                damage: 1,
                abilities: [
                  {
                    description: "Hit roll of 6 (unmodified) : 2 extra hits",
                    conditions: [
                      {
                        data: {
                          attackStep: {
                            title: "Hit roll",
                            key: "hitRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Exact",
                            key: "exact",
                          },
                          rollValue: "6",
                        },
                        preselected: false,
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        required: true,
                      },
                    ],
                    effect: {
                      data: {
                        option: {
                          title: "Extra hits",
                          key: "extraHits",
                        },
                        extrasValue: "2",
                      },
                      text: "Generate extras",
                      type: "generateExtras",
                    },
                    scope: ["weapon"],
                    id: "5f1cb2a9-331c-4490-a755-a6ce21ebed8e",
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "429b5f02-7987-40f7-8e84-f1985a8ffa6d",
                countPerUnit: 1,
                bs: null,
                ws: 3,
                nameUnique: "Taser goad",
              },
            ],
            id: "573b9cd4-a69f-40c7-9f30-9f7cddab50eb",
            name: "A: Melee - taser weapons > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: ["429b5f02-7987-40f7-8e84-f1985a8ffa6d"],
    weapons_selected_ranged: [],
  },
  {
    name: "A: Laser chickens x3",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "da0cc1c1-8a5c-4f78-9bc7-b378b367c27e",
        modelTypeName: null,
        unitId: "6f84af37-f836-4f8f-af88-8470cd0429be",
      },
    ],
    units: [
      {
        id: "6f84af37-f836-4f8f-af88-8470cd0429be",
        leader: false,
        name: "A: Laser chickens x3 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Twin cognis lascannon",
                countPerUnit: "3",
                type: "Ranged",
                attacks: 2,
                strength: 9,
                ap: -3,
                damage: "D3+3",
                id: "2ba970d1-e43a-444b-8343-be358f640bed",
                bs: 3,
                ws: null,
                nameUnique: "Twin cognis lascannon",
                abilities: [],
              },
            ],
            id: "da0cc1c1-8a5c-4f78-9bc7-b378b367c27e",
            name: "A: Laser chickens x3 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["2ba970d1-e43a-444b-8343-be358f640bed"],
  },
  {
    name: "A: Melee WS2 various hit re-rolls",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Melee"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "b6b08d9d-4921-4109-bb0d-fe05006b2d4e",
        modelTypeName: null,
        unitId: "bf79f0e0-6e39-4712-8729-6945ef034e38",
      },
    ],
    units: [
      {
        id: "bf79f0e0-6e39-4712-8729-6945ef034e38",
        leader: false,
        name: "A: Melee WS2 various hit re-rolls > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Sword (hits rr all possible failures)",
                type: "Melee",
                attacks: 6,
                strength: 8,
                ap: -4,
                damage: 3,
                abilities: [
                  {
                    description: "Re-roll all possible failed hit rolls",
                    scope: ["weapon"],
                    id: "4c9b8a79-820d-4fb6-bd11-772a7601101e",
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        limit: {
                          title: "None",
                          key: "none",
                        },
                        resultToReRoll: {
                          title: "All possible failures",
                          key: "allPossibleFailures",
                        },
                        valueRange: [],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "3e6efccc-f781-4064-bd0d-7de37c603941",
                countPerUnit: 1,
                bs: null,
                ws: 2,
                nameUnique: "Sword (hits rr all possible failures)",
              },
              {
                name: "Sword (hits rr 1-2)",
                type: "Melee",
                attacks: 6,
                strength: 8,
                ap: -4,
                damage: 3,
                abilities: [
                  {
                    description: "Re-roll all hit roll results of 1–2",
                    scope: ["weapon"],
                    id: "513fcf14-8857-49e7-bb70-de5f0f745663",
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        limit: {
                          title: "None",
                          key: "none",
                        },
                        resultToReRoll: {
                          title: "Range",
                          key: "range",
                        },
                        valueRange: [1, 2],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "becde3fb-3c03-494c-a449-9a68b4ccca9b",
                countPerUnit: 1,
                bs: null,
                ws: 2,
                nameUnique: "Sword (hits rr 1-2)",
              },
              {
                name: "Sword (hits rr all failed)",
                type: "Melee",
                attacks: 6,
                strength: 8,
                ap: -4,
                damage: 3,
                abilities: [
                  {
                    description: "Re-roll all possible failed hit rolls",
                    scope: ["weapon"],
                    id: "afb0b847-2e9c-473d-b2b2-4f1ca7c8e728",
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        limit: {
                          title: "None",
                          key: "none",
                        },
                        resultToReRoll: {
                          title: "All possible failures",
                          key: "allPossibleFailures",
                        },
                        valueRange: [],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "7efd3063-4f1f-48cb-8d13-4a26f087be69",
                countPerUnit: 1,
                bs: null,
                ws: 2,
                nameUnique: "Sword (hits rr all failed)",
              },
              {
                name: "Sword (hits rr 1s)",
                type: "Melee",
                attacks: 6,
                strength: 8,
                ap: -4,
                damage: 3,
                abilities: [
                  {
                    description: "Re-roll all hit roll results of 1",
                    scope: ["weapon"],
                    id: "873cd541-d56a-431c-a7cc-07d8a72c3040",
                    effect: {
                      data: {
                        application: {
                          title: "Hit roll",
                          key: "hitRoll",
                        },
                        limit: {
                          title: "None",
                          key: "none",
                        },
                        resultToReRoll: {
                          title: "Single",
                          key: "single",
                        },
                        valueRange: [],
                        valueSingle: 1,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "9a4ece4c-92be-40f8-8c0b-8cba95b56328",
                countPerUnit: 1,
                bs: null,
                ws: 2,
                nameUnique: "Sword (hits rr 1s)",
              },
            ],
            id: "b6b08d9d-4921-4109-bb0d-fe05006b2d4e",
            name: "A: Melee WS2 various hit re-rolls > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [
      "3e6efccc-f781-4064-bd0d-7de37c603941",
      "becde3fb-3c03-494c-a449-9a68b4ccca9b",
      "7efd3063-4f1f-48cb-8d13-4a26f087be69",
      "9a4ece4c-92be-40f8-8c0b-8cba95b56328",
    ],
    weapons_selected_ranged: [],
  },
  {
    name: "A: Melee WS2 various wound re-rolls",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Melee"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "de203fc1-aad8-4146-b435-4bac21594ae2",
        modelTypeName: null,
        unitId: "fe271c70-94e3-40ed-b368-f2e7c1e467bc",
      },
    ],
    units: [
      {
        id: "fe271c70-94e3-40ed-b368-f2e7c1e467bc",
        leader: false,
        name: "A: Melee WS2 various wound re-rolls > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Sword (wounds rr all possible failures)",
                type: "Melee",
                attacks: 6,
                strength: 8,
                ap: -4,
                damage: 3,
                abilities: [
                  {
                    description: "Re-roll all possible failed wound rolls",
                    scope: ["weapon"],
                    id: "baee1244-c01a-4d52-973e-92b5067d9846",
                    effect: {
                      data: {
                        application: {
                          title: "Wound roll",
                          key: "woundRoll",
                        },
                        limit: {
                          title: "None",
                          key: "none",
                        },
                        resultToReRoll: {
                          title: "All possible failures",
                          key: "allPossibleFailures",
                        },
                        valueRange: [],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [
                      {
                        name: "Twin-linked",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "35385c6b-7df4-4e32-b73a-e5951e739e04",
                countPerUnit: 1,
                bs: null,
                ws: 2,
                nameUnique: "Sword (wounds rr all possible failures)",
              },
              {
                name: "Sword (wounds rr 1-2)",
                type: "Melee",
                attacks: 6,
                strength: 8,
                ap: -4,
                damage: 3,
                abilities: [
                  {
                    description: "Re-roll all wound roll results of 1–2",
                    scope: ["weapon"],
                    id: "bd043206-9988-4347-a6f4-2de1a0238dec",
                    effect: {
                      data: {
                        application: {
                          title: "Wound roll",
                          key: "woundRoll",
                        },
                        limit: {
                          title: "None",
                          key: "none",
                        },
                        resultToReRoll: {
                          title: "Range",
                          key: "range",
                        },
                        valueRange: [1, 2],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "6a56237a-24c5-41fc-a161-96b68ccba48d",
                countPerUnit: 1,
                bs: null,
                ws: 2,
                nameUnique: "Sword (wounds rr 1-2)",
              },
              {
                name: "Sword (wounds rr all failed)",
                type: "Melee",
                attacks: 6,
                strength: 8,
                ap: -4,
                damage: 3,
                abilities: [
                  {
                    description: "Re-roll all possible failed wound rolls",
                    scope: ["weapon"],
                    id: "4a633088-d283-4970-a74e-6ec189835f4b",
                    effect: {
                      data: {
                        application: {
                          title: "Wound roll",
                          key: "woundRoll",
                        },
                        limit: {
                          title: "None",
                          key: "none",
                        },
                        resultToReRoll: {
                          title: "All possible failures",
                          key: "allPossibleFailures",
                        },
                        valueRange: [],
                        valueSingle: null,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "69c2232a-c53d-4332-ae0d-355cf078234d",
                countPerUnit: 1,
                bs: null,
                ws: 2,
                nameUnique: "Sword (wounds rr all failed)",
              },
              {
                name: "Sword (wounds rr 1s)",
                type: "Melee",
                attacks: 6,
                strength: 8,
                ap: -4,
                damage: 3,
                abilities: [
                  {
                    description: "Re-roll all wound roll results of 1",
                    scope: ["weapon"],
                    id: "3e6467b5-38de-49a1-8bfd-9d6891fbd8d8",
                    effect: {
                      data: {
                        application: {
                          title: "Wound roll",
                          key: "woundRoll",
                        },
                        limit: {
                          title: "None",
                          key: "none",
                        },
                        resultToReRoll: {
                          title: "Single",
                          key: "single",
                        },
                        valueRange: [],
                        valueSingle: 1,
                      },
                      text: "Re-roll",
                      type: "reRoll",
                    },
                    conditions: [],
                    aliases: [],
                    aliasActive: true,
                    sharedWithAllUnits: false,
                  },
                ],
                id: "29a37a59-57db-430e-a292-84b02606992b",
                countPerUnit: 1,
                bs: null,
                ws: 2,
                nameUnique: "Sword (wounds rr 1s)",
              },
            ],
            id: "de203fc1-aad8-4146-b435-4bac21594ae2",
            name: "A: Melee WS2 various wound re-rolls > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [
      "35385c6b-7df4-4e32-b73a-e5951e739e04",
      "6a56237a-24c5-41fc-a161-96b68ccba48d",
      "69c2232a-c53d-4332-ae0d-355cf078234d",
      "29a37a59-57db-430e-a292-84b02606992b",
    ],
    weapons_selected_ranged: [],
  },
  {
    name: "A: Melee WS4 S4 A20",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Melee"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "e1ee6256-818b-4ec0-8165-55fa579db22a",
        modelTypeName: null,
        unitId: "8ea8cb00-6587-488f-91c4-a7a5a8ed41d9",
      },
    ],
    units: [
      {
        id: "8ea8cb00-6587-488f-91c4-a7a5a8ed41d9",
        leader: false,
        name: "A: Melee WS4 S4 A20 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Close combat weapon",
                type: "Melee",
                attacks: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "ff38b371-7743-4e3e-ab9a-c532f0aa0255",
                countPerUnit: 10,
                bs: null,
                ws: 4,
                nameUnique: "Close combat weapon",
                abilities: [],
              },
            ],
            id: "e1ee6256-818b-4ec0-8165-55fa579db22a",
            name: "A: Melee WS4 S4 A20 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: ["ff38b371-7743-4e3e-ab9a-c532f0aa0255"],
    weapons_selected_ranged: [],
  },
  {
    name: "A: Strength characteristic test",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Melee", "Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "c6b2b168-4958-49ce-988a-3ea06fae9c3d",
        modelTypeName: null,
        unitId: "66fb697c-e702-4f7d-9f20-2aa9abc79302",
      },
    ],
    units: [
      {
        id: "66fb697c-e702-4f7d-9f20-2aa9abc79302",
        leader: false,
        name: "A: Strength characteristic test > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "S7 gun",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 12,
                strength: 7,
                ap: -3,
                damage: 2,
                id: "d2d4b763-0c9c-40b6-b4d7-045b87a563fe",
                bs: 2,
                ws: null,
                nameUnique: "S7 gun",
                abilities: [],
              },
              {
                name: "S8 gun",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 12,
                strength: 8,
                ap: -3,
                damage: 2,
                id: "64fd8a03-9ade-405f-9a13-ff30a34b0445",
                bs: 2,
                ws: null,
                nameUnique: "S8 gun",
                abilities: [],
              },
              {
                name: "S User gun",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 12,
                strength: 7,
                ap: -3,
                damage: 2,
                id: "17a903cc-7537-4ead-a695-fbbf918e74d7",
                bs: 2,
                ws: null,
                nameUnique: "S User gun",
                abilities: [],
              },
              {
                name: "S +1 gun",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 12,
                strength: 8,
                ap: -3,
                damage: 2,
                id: "79d4c53d-58b8-49ff-90bf-2e24a6cfe746",
                bs: 2,
                ws: null,
                nameUnique: "S +1 gun",
                abilities: [],
              },
              {
                name: "Axe S User",
                type: "Melee",
                attacks: 12,
                strength: 7,
                ap: -3,
                damage: 2,
                id: "687fc393-6dca-4e4b-9ff8-9c593dc6d646",
                countPerUnit: 1,
                bs: null,
                ws: 2,
                nameUnique: "Axe S User",
                abilities: [],
              },
              {
                name: "Axe S +1",
                type: "Melee",
                attacks: 12,
                strength: 8,
                ap: -3,
                damage: 2,
                id: "450a3159-24f0-4591-a604-fdd48fecf6c4",
                countPerUnit: 1,
                bs: null,
                ws: 2,
                nameUnique: "Axe S +1",
                abilities: [],
              },
            ],
            id: "c6b2b168-4958-49ce-988a-3ea06fae9c3d",
            name: "A: Strength characteristic test > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [
      "687fc393-6dca-4e4b-9ff8-9c593dc6d646",
      "450a3159-24f0-4591-a604-fdd48fecf6c4",
    ],
    weapons_selected_ranged: [
      "d2d4b763-0c9c-40b6-b4d7-045b87a563fe",
      "64fd8a03-9ade-405f-9a13-ff30a34b0445",
      "17a903cc-7537-4ead-a695-fbbf918e74d7",
      "79d4c53d-58b8-49ff-90bf-2e24a6cfe746",
    ],
  },
  {
    name: "A: AP to 0 characteristic test",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "d8d85143-fa31-4dd4-a451-ed405faa247e",
        modelTypeName: null,
        unitId: "d3703647-a129-474f-9a09-d3e7ed3aa25a",
      },
    ],
    units: [
      {
        id: "d3703647-a129-474f-9a09-d3e7ed3aa25a",
        leader: false,
        name: "A: AP to 0 characteristic test > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "AP 0 gun",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 12,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "00ded321-d0ea-417d-9d1e-9245c3210d14",
                bs: 2,
                ws: null,
                nameUnique: "AP 0 gun",
                abilities: [],
              },
              {
                name: "AP -1 gun",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 12,
                strength: 4,
                ap: -1,
                damage: 1,
                id: "2fc52f47-11b5-46e4-be68-c3ebee2dec60",
                bs: 2,
                ws: null,
                nameUnique: "AP -1 gun",
                abilities: [],
              },
              {
                name: "AP -2 gun",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 12,
                strength: 4,
                ap: -2,
                damage: 1,
                id: "b3e5618a-4b6b-489d-a860-c6a0a09d9028",
                bs: 2,
                ws: null,
                nameUnique: "AP -2 gun",
                abilities: [],
              },
              {
                name: "AP -3 gun",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 12,
                strength: 4,
                ap: -3,
                damage: 1,
                id: "71ba8a0d-1005-4f3f-a1fe-d379081d61a8",
                bs: 2,
                ws: null,
                nameUnique: "AP -3 gun",
                abilities: [],
              },
            ],
            id: "d8d85143-fa31-4dd4-a451-ed405faa247e",
            name: "A: AP to 0 characteristic test > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "00ded321-d0ea-417d-9d1e-9245c3210d14",
      "2fc52f47-11b5-46e4-be68-c3ebee2dec60",
      "b3e5618a-4b6b-489d-a860-c6a0a09d9028",
      "71ba8a0d-1005-4f3f-a1fe-d379081d61a8",
    ],
  },
  {
    name: "A: Damage characteristic test",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "97586f7e-44a2-4dcd-89cf-48f6ca57a350",
        modelTypeName: null,
        unitId: "7f80a6fd-c1b6-4859-969a-d7a914f927c3",
      },
    ],
    units: [
      {
        id: "7f80a6fd-c1b6-4859-969a-d7a914f927c3",
        leader: false,
        name: "A: Damage characteristic test > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Damage 1 gun",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 12,
                strength: 6,
                ap: 0,
                damage: 1,
                id: "1b4adc60-7887-4905-a6fb-ea81cd94266a",
                bs: 2,
                ws: null,
                nameUnique: "Damage 1 gun",
                abilities: [],
              },
              {
                name: "Damage 2 gun",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 12,
                strength: 6,
                ap: 0,
                damage: 2,
                id: "3a745289-0266-4d81-8a67-856b092e93f2",
                bs: 2,
                ws: null,
                nameUnique: "Damage 2 gun",
                abilities: [],
              },
              {
                name: "Damage D3 gun",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 12,
                strength: 6,
                ap: 0,
                damage: "D3",
                id: "ca5d80a3-19dc-4820-841d-fb0e609ff17e",
                bs: 2,
                ws: null,
                nameUnique: "Damage D3 gun",
                abilities: [],
              },
            ],
            id: "97586f7e-44a2-4dcd-89cf-48f6ca57a350",
            name: "A: Damage characteristic test > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "1b4adc60-7887-4905-a6fb-ea81cd94266a",
      "3a745289-0266-4d81-8a67-856b092e93f2",
      "ca5d80a3-19dc-4820-841d-fb0e609ff17e",
    ],
  },
  {
    name: "A: Bolt pistol, BS2",
    computed_keywords: [],
    computed_leaders: [],
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "b5b3e9c2-3e98-4666-8a5c-49f11e201b64",
        modelTypeName: null,
        unitId: "828e19a8-0fec-4a55-ac88-d1482a10cddc",
      },
    ],
    units: [
      {
        id: "828e19a8-0fec-4a55-ac88-d1482a10cddc",
        leader: false,
        name: "A: Bolt pistol, BS2 > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            weapons: [
              {
                name: "Bolt pistol",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 1,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "8358584c-d811-4d62-bab6-421350c293f5",
                bs: 2,
                ws: null,
                nameUnique: "Bolt pistol",
                abilities: [],
              },
            ],
            id: "b5b3e9c2-3e98-4666-8a5c-49f11e201b64",
            name: "A: Bolt pistol, BS2 > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["8358584c-d811-4d62-bab6-421350c293f5"],
  },
  {
    name: "A: Lethal hits, +1 to wound & Re-roll wounds with TORRENT & non-TORRENT weapons",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: null,
    computed_points: null,
    computed_roles: ["Attacker: Ranged"],
    computed_toughness: 0,
    computed_wounds: null,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "0790633e-3c32-4c44-95d5-49942f0fcb29",
        modelTypeName:
          "A: Lethal hits, +1 to wound & Re-roll wounds with TORRENT & non-TORRENT weapons",
        unitId: "3e66d23d-6d4a-4120-95ab-d84008e44280",
      },
    ],
    units: [
      {
        abilities: [
          {
            id: "fc117c3f-93dd-4bab-8cb2-d202781bf6da",
            scope: ["profile"],
            effect: {
              data: {
                crit: false,
                type: {
                  key: "always",
                  title: "Always",
                },
                outcome: {
                  key: "wound",
                  title: "Wound",
                },
                irrespective: false,
              },
              text: "Override requirements",
              type: "overrideReqs",
            },
            aliases: [
              {
                name: "Lethal hits",
                type: "reserved",
              },
            ],
            conditions: [
              {
                data: {
                  profileRole: "Attacker",
                },
                text: "Profile role",
                type: "profileRole",
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
              },
              {
                data: {
                  crit: {
                    key: "hitRoll",
                    title: "Critical hit",
                  },
                },
                text: "Critical hit/wound",
                type: "crit",
                description: 'Require a hit or wound to be "critical".',
                preselected: false,
              },
            ],
            aliasActive: true,
            description: "Critical hit : always wound (if attacker)",
            sharedWithAllUnits: false,
          },
          {
            id: "bcd4f514-ef00-424d-899d-639c62ab4fc7",
            scope: ["profile"],
            effect: {
              data: {
                operator: {
                  key: "add",
                  title: "Add",
                },
                application: {
                  key: "woundRoll",
                  title: "Wound roll",
                },
                relativeValue: "1",
              },
              text: "Modify (relative)",
              type: "modifyRelative",
            },
            aliases: [],
            conditions: [
              {
                data: {
                  profileRole: "Attacker",
                },
                text: "Profile role",
                type: "profileRole",
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
              },
            ],
            aliasActive: true,
            description: "+1 to wound roll (if attacker)",
            sharedWithAllUnits: false,
          },
          {
            id: "2ae0aa78-dc6a-4250-8994-5ddb76f684a5",
            scope: ["profile"],
            effect: {
              data: {
                limit: {
                  key: "none",
                  title: "No limit",
                  dataCySuffix: "none",
                },
                valueRange: [],
                application: {
                  key: "woundRoll",
                  title: "Wound roll",
                },
                valueSingle: null,
                resultToReRoll: {
                  key: "allPossibleFailures",
                  title: "All possible failures",
                  applications: [
                    "hitRoll",
                    "invulnSaveRoll",
                    "saveRoll",
                    "woundRoll",
                  ],
                  dataCySuffix: "all-possible-failures",
                },
              },
              text: "Re-roll",
              type: "reRoll",
            },
            aliases: [],
            conditions: [
              {
                data: {
                  profileRole: "Attacker",
                },
                text: "Profile role",
                type: "profileRole",
                scope: ["global", "profile", "weapon"],
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
              },
            ],
            aliasActive: true,
            description:
              "Re-roll all possible failed wound rolls (if attacker)",
            sharedWithAllUnits: false,
          },
        ],
        id: "3e66d23d-6d4a-4120-95ab-d84008e44280",
        leader: false,
        points: null,
        model_types: [
          {
            ignore: null,
            invuln: null,
            keywords: [],
            modelCount: null,
            name: "A: Lethal hits, +1 to wound & Re-roll wounds with TORRENT & non-TORRENT weapons",
            save: null,
            toughness: null,
            weapons: [
              {
                name: "Not TORRENT weapon",
                countPerUnit: 4,
                type: "Ranged",
                attacks: 5,
                bs: 2,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "c234d73e-31c0-4c4e-9cd2-d867275098ca",
                nameUnique: "Not TORRENT weapon",
                abilities: [],
              },
              {
                name: "TORRENT weapon",
                countPerUnit: 4,
                type: "Ranged",
                attacks: 4,
                bs: "",
                strength: 4,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    id: "edf53a5f-fc50-4b74-8c03-fe7a7f766901",
                    scope: ["weapon"],
                    effect: {
                      data: {
                        crit: false,
                        type: {
                          key: "always",
                          title: "Always",
                        },
                        outcome: {
                          key: "hit",
                          title: "Hit",
                        },
                        irrespective: false,
                      },
                      text: "Override requirements",
                      type: "overrideReqs",
                    },
                    aliases: [
                      {
                        name: "Torrent",
                        type: "reserved",
                      },
                    ],
                    conditions: [],
                    aliasActive: true,
                    description: "Always hit",
                    sharedWithAllUnits: false,
                  },
                ],
                id: "f0a4cc44-0fd6-4aae-9bf0-b960b0d4931d",
                nameUnique: "TORRENT weapon",
              },
            ],
            wounds: null,
            id: "0790633e-3c32-4c44-95d5-49942f0fcb29",
          },
        ],
        name: "A: Lethal hits, +1 to wound & Re-roll wounds with TORRENT & non-TORRENT weapons > Unit 1",
        abilities_selected: [
          "bcd4f514-ef00-424d-899d-639c62ab4fc7",
          "2ae0aa78-dc6a-4250-8994-5ddb76f684a5",
        ],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["c234d73e-31c0-4c4e-9cd2-d867275098ca"],
  },
]
